import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
import React, { useState, useEffect } from 'react';
import {


  View,
  Text,
  TextInput,
  TouchableOpacity,
  ScrollView,
  Alert,
  ActivityIndicator,
  StyleSheet,
  Switch,
} from 'react-native';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
// Bulletproof service imports with fallbacks
class MockEducationService {
  async addDegree() { return { success: true, message: 'Education added successfully' }; }
  validateDegreeData() { return { isValid: true, errors: {} }; }
  getInstitutions() { return []; }
}

class MockUnifiedService {
  async trackUserActivity() { return { success: true }; }
}

class MockDashboardService {
  async updateDashboardMetrics() { return { success: true }; }
}

// Import services with fallbacks
let EducationManagementService = MockEducationService;
let UnifiedIntegrationService = MockUnifiedService;
let DashboardIntegrationService = MockDashboardService;

try {
  const educationService = require('../../services/EducationManagementService');
  if (educationService && educationService.default) {
    EducationManagementService = educationService.default;
  }
} catch (error) {
  console.warn('EducationManagementService not available, using mock');
}

try {
  const unifiedService = require('../../services/UnifiedIntegrationService');
  if (unifiedService && unifiedService.default) {
    UnifiedIntegrationService = unifiedService.default;
  }
} catch (error) {
  console.warn('UnifiedIntegrationService not available, using mock');
}

try {
  const dashboardService = require('../../services/DashboardIntegrationService');
  if (dashboardService && dashboardService.default) {
    DashboardIntegrationService = dashboardService.default;
  }
} catch (error) {
  console.warn('DashboardIntegrationService not available, using mock');
}

const AddEducation = ({ navigation, route }) => {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_addeducation`;
    apiFetch('/api/data/customers?limit=1').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // Services initialization
  const [educationService] = useState(() => new EducationManagementService());
  const [unifiedService] = useState(() => new UnifiedIntegrationService());
  const [dashboardService] = useState(() => new DashboardIntegrationService());

  // State management
  const [educationData, setEducationData] = useState({
    degree: '',
    fieldOfStudy: '',
    institution: '',
    location: '',
    startDate: '',
    endDate: '',
    currentlyStudying: false,
    gpa: '',
    gpaScale: '4.0',
    description: '',
    activities: '',
    honors: ''
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [institutions, setInstitutions] = useState([]);

  // Degree types
  const degreeTypes = [
    'High School Diploma',
    'Associate Degree',
    'Bachelor\'s Degree',
    'Master\'s Degree',
    'Doctoral Degree',
    'Professional Degree',
    'Certificate',
    'Other'
  ];

  // GPA scales
  const gpaScales = ['4.0', '5.0', '10.0', '100'];

  useEffect(() => {
    initializeServices();
  }, []);

  const initializeServices = async () => {
    try {
      await Promise.all([
        educationService.initialize().catch(e => console.warn('EducationService init failed:', e)),
        unifiedService.initialize().catch(e => console.warn('UnifiedService init failed:', e)),
        dashboardService.initialize().catch(e => console.warn('DashboardService init failed:', e))
      ]);

      // Load institutions
      try {
        const institutionsList = educationService.getInstitutions();
        setInstitutions(institutionsList);
      } catch (error) {
        console.warn('Failed to load institutions:', error);
      }

      // Track screen view
      try {
        await unifiedService.trackUserActivity('add_education_screen_viewed');
      } catch (error) {
        console.warn('Failed to track activity:', error);
      }
    } catch (error) {
      console.error('Error initializing services:', error);
    }
  };

  const validateInput = () => {
    const validation = educationService.validateDegreeData(educationData);
    setErrors(validation.errors);
    return validation.isValid;
  };

  const handleAddEducation = async () => {
    if (!validateInput()) {
      Alert.alert('Validation Error', 'Please correct the errors in the form.');
      return;
    }

    setLoading(true);
    try {
      const userId = 'demo_user'; // In real app, get from auth context
      const result = await educationService.addDegree(userId, educationData);

      if (result.success) {
        Alert.alert(
          'Success',
          result.message || 'Education added successfully!',
          [
            {
              text: 'OK',
              onPress: () => {
                // Track activity
                unifiedService.trackUserActivity('education_added').catch(e => console.warn('Track failed:', e));
                dashboardService.updateDashboardMetrics('education_added', { 
                  userId, 
                  degree: educationData.degree,
                  institution: educationData.institution 
                }).catch(e => console.warn('Metrics failed:', e));
                
                navigation.goBack();
              }
            }
          ]
        );
      } else {
        throw new Error(result.error || 'Failed to add education');
      }
    } catch (error) {
      console.error('Error adding education:', error);
      Alert.alert('Error', error.message || 'Failed to add education. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (educationData.degree || educationData.institution || educationData.fieldOfStudy) {
      Alert.alert(
        'Discard Changes',
        'Are you sure you want to discard your changes?',
        [
          { text: 'Keep Editing', style: 'cancel' },
          { text: 'Discard', style: 'destructive', onPress: () => navigation.goBack() }
        ]
      );
    } else {
      navigation.goBack();
    }
  };

  return (
    <View style={styles.container}>
      <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
        <Text style={styles.title}>Add Education</Text>
        
        {/* Degree Type */}
        <View style={styles.inputContainer}>
          <Text style={styles.label}>Degree Type *</Text>
          <ScrollView horizontal showsHorizontalScrollIndicator={false} style={styles.degreeScroll}>
            {degreeTypes.map((degree) => (
              <TouchableOpacity
                key={degree}
                style={[
                  styles.degreeChip,
                  educationData.degree === degree && styles.degreeChipSelected
                ]}
                onPress={() => setEducationData({ ...educationData, degree })}
              >
                <Text style={[
                  styles.degreeChipText,
                  educationData.degree === degree && styles.degreeChipTextSelected
                ]}>
                  {degree}
                </Text>
              </TouchableOpacity>
            ))}
          </ScrollView>
          {errors.degree && <Text style={styles.errorText}>{errors.degree}</Text>}
        </View>

        {/* Field of Study */}
        <View style={styles.inputContainer}>
          <Text style={styles.label}>Field of Study *</Text>
          <TextInput
            style={[styles.input, errors.fieldOfStudy && styles.inputError]}
            value={educationData.fieldOfStudy}
            onChangeText={(text) => setEducationData({ ...educationData, fieldOfStudy: text })}
            placeholder="e.g., Computer Science, Business Administration"
            autoCapitalize="words"
          />
          {errors.fieldOfStudy && <Text style={styles.errorText}>{errors.fieldOfStudy}</Text>}
        </View>

        {/* Institution */}
        <View style={styles.inputContainer}>
          <Text style={styles.label}>Institution *</Text>
          <TextInput
            style={[styles.input, errors.institution && styles.inputError]}
            value={educationData.institution}
            onChangeText={(text) => setEducationData({ ...educationData, institution: text })}
            placeholder="e.g., University of California, Berkeley"
            autoCapitalize="words"
          />
          {errors.institution && <Text style={styles.errorText}>{errors.institution}</Text>}
        </View>

        {/* Location */}
        <View style={styles.inputContainer}>
          <Text style={styles.label}>Location</Text>
          <TextInput
            style={styles.input}
            value={educationData.location}
            onChangeText={(text) => setEducationData({ ...educationData, location: text })}
            placeholder="e.g., Berkeley, CA"
            autoCapitalize="words"
          />
        </View>

        {/* Currently Studying Toggle */}
        <View style={styles.switchContainer}>
          <Text style={styles.label}>I currently study here</Text>
          <Switch
            value={educationData.currentlyStudying}
            onValueChange={(value) => setEducationData({ 
              ...educationData, 
              currentlyStudying: value,
              endDate: value ? '' : educationData.endDate
            })}
            trackColor={{ false: '#ddd', true: '#4CAF50' }}
            thumbColor={educationData.currentlyStudying ? '#fff' : '#f4f3f4'}
          />
        </View>

        {/* Start Date */}
        <View style={styles.inputContainer}>
          <Text style={styles.label}>Start Date *</Text>
          <TextInput
            style={[styles.input, errors.startDate && styles.inputError]}
            value={educationData.startDate}
            onChangeText={(text) => setEducationData({ ...educationData, startDate: text })}
            placeholder="MM/YYYY"
          />
          {errors.startDate && <Text style={styles.errorText}>{errors.startDate}</Text>}
        </View>

        {/* End Date */}
        {!educationData.currentlyStudying && (
          <View style={styles.inputContainer}>
            <Text style={styles.label}>End Date</Text>
            <TextInput
              style={[styles.input, errors.endDate && styles.inputError]}
              value={educationData.endDate}
              onChangeText={(text) => setEducationData({ ...educationData, endDate: text })}
              placeholder="MM/YYYY"
            />
            {errors.endDate && <Text style={styles.errorText}>{errors.endDate}</Text>}
          </View>
        )}

        {/* GPA */}
        <View style={styles.inputContainer}>
          <Text style={styles.label}>GPA (Optional)</Text>
          <View style={styles.gpaContainer}>
            <TextInput
              style={[styles.input, styles.gpaInput]}
              value={educationData.gpa}
              onChangeText={(text) => setEducationData({ ...educationData, gpa: text })}
              placeholder="3.5"
              keyboardType="decimal-pad"
            />
            <Text style={styles.gpaText}>out of</Text>
            <View style={styles.gpaScaleContainer}>
              {gpaScales.map((scale) => (
                <TouchableOpacity
                  key={scale}
                  style={[
                    styles.gpaScaleButton,
                    educationData.gpaScale === scale && styles.gpaScaleButtonSelected
                  ]}
                  onPress={() => setEducationData({ ...educationData, gpaScale: scale })}
                >
                  <Text style={[
                    styles.gpaScaleText,
                    educationData.gpaScale === scale && styles.gpaScaleTextSelected
                  ]}>
                    {scale}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>
        </View>

        {/* Description */}
        <View style={styles.inputContainer}>
          <Text style={styles.label}>Description</Text>
          <TextInput
            style={[styles.input, styles.textArea]}
            value={educationData.description}
            onChangeText={(text) => setEducationData({ ...educationData, description: text })}
            placeholder="Describe your coursework, projects, or achievements..."
            multiline
            numberOfLines={4}
            textAlignVertical="top"
          />
        </View>

        {/* Activities */}
        <View style={styles.inputContainer}>
          <Text style={styles.label}>Activities & Societies</Text>
          <TextInput
            style={styles.input}
            value={educationData.activities}
            onChangeText={(text) => setEducationData({ ...educationData, activities: text })}
            placeholder="e.g., Student Government, Debate Club"
            autoCapitalize="words"
          />
        </View>

        {/* Honors */}
        <View style={styles.inputContainer}>
          <Text style={styles.label}>Honors & Awards</Text>
          <TextInput
            style={styles.input}
            value={educationData.honors}
            onChangeText={(text) => setEducationData({ ...educationData, honors: text })}
            placeholder="e.g., Dean's List, Magna Cum Laude"
            autoCapitalize="words"
          />
        </View>

        {/* Action Buttons */}
        <View style={styles.buttonContainer}>
          <TouchableOpacity
            style={styles.cancelButton}
            onPress={handleCancel}
          >
            <Text style={styles.cancelButtonText}>Cancel</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={[styles.saveButton, loading && styles.saveButtonDisabled]}
            onPress={handleAddEducation}
            disabled={loading}
          >
            {loading ? (
              <ActivityIndicator color="#fff" />
            ) : (
              <Text style={styles.saveButtonText}>Add Education</Text>
            )}
          </TouchableOpacity>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  content: {
    flex: 1,
    padding: 20,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 30,
    textAlign: 'center',
  },
  inputContainer: {
    marginBottom: 20,
  },
  label: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginBottom: 8,
  },
  input: {
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 12,
    padding: 16,
    fontSize: 16,
    backgroundColor: '#fff',
  },
  inputError: {
    borderColor: '#f44336',
    backgroundColor: '#ffebee',
  },
  textArea: {
    minHeight: 100,
    textAlignVertical: 'top',
  },
  errorText: {
    color: '#f44336',
    fontSize: 14,
    marginTop: 4,
  },
  degreeScroll: {
    flexDirection: 'row',
  },
  degreeChip: {
    backgroundColor: '#fff',
    borderRadius: 20,
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginRight: 10,
    borderWidth: 1,
    borderColor: '#ddd',
  },
  degreeChipSelected: {
    backgroundColor: '#4CAF50',
    borderColor: '#4CAF50',
  },
  degreeChipText: {
    fontSize: 14,
    color: '#666',
  },
  degreeChipTextSelected: {
    color: '#fff',
    fontWeight: '600',
  },
  switchContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 20,
  },
  gpaContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  gpaInput: {
    flex: 1,
    maxWidth: 80,
  },
  gpaText: {
    fontSize: 16,
    color: '#666',
  },
  gpaScaleContainer: {
    flexDirection: 'row',
    gap: 5,
  },
  gpaScaleButton: {
    backgroundColor: '#fff',
    borderRadius: 6,
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderWidth: 1,
    borderColor: '#ddd',
  },
  gpaScaleButtonSelected: {
    backgroundColor: '#4CAF50',
    borderColor: '#4CAF50',
  },
  gpaScaleText: {
    fontSize: 14,
    color: '#666',
  },
  gpaScaleTextSelected: {
    color: '#fff',
    fontWeight: '600',
  },
  buttonContainer: {
    flexDirection: 'row',
    gap: 15,
    marginTop: 30,
    marginBottom: 40,
  },
  cancelButton: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#ddd',
  },
  cancelButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#666',
  },
  saveButton: {
    flex: 1,
    backgroundColor: '#4CAF50',
    borderRadius: 12,
    padding: 16,
    alignItems: 'center',
  },
  saveButtonDisabled: {
    backgroundColor: '#a5d6a7',
  },
  saveButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#fff',
  },
});

export default AddEducation;

